import { computed, ref } from 'vue';

import type { CartDetailsItemResponse } from '@/types/carts-transactions-api';

export function useContactFieldsCompletion(
  enrichedCartItems: () => CartDetailsItemResponse[],
  isItemExpired: (item: CartDetailsItemResponse) => boolean,
) {
  const contactFieldsCompletion = ref(new Map<string, boolean>());

  function handleContactFieldsCompleted(itemId: string, isCompleted: boolean) {
    contactFieldsCompletion.value.set(itemId, isCompleted);
  }

  const allContactFieldsCompleted = computed(() => {
    return enrichedCartItems()
      .filter(item => !isItemExpired(item))
      .every((item) => {
        if (!item.hasRequiredContactFields)
          return true;
        return contactFieldsCompletion.value.get(item.itemId) === true;
      });
  });

  const isPaymentBlocked = computed(() => !allContactFieldsCompleted.value);

  return {
    handleContactFieldsCompleted,
    isPaymentBlocked,
  };
}
